import type { FC } from 'react';
import { Stack, Typography } from '@mui/material';

import type { NpsQuestionBarProps } from './constants';
import NpsQuestionBar from './NpsQuestionBar';

export interface NpsQuestionProps {
  question: string;
  nps: NpsQuestionBarProps;
  comparisonNps?: NpsQuestionBarProps;
}

const NpsQuestion: FC<NpsQuestionProps> = ({
  nps,
  question,
  comparisonNps,
}) => (
  <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
    <Typography variant="body3" sx={{ fontWeight: 600, width: '50%' }}>
      {question}
    </Typography>
    <Stack direction="column" sx={{ width: '50%', flexGrow: 1 }}>
      <NpsQuestionBar {...nps} />
      {comparisonNps && <NpsQuestionBar {...comparisonNps} isComparison />}
    </Stack>
  </Stack>
);

export default NpsQuestion;
